import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=000a31da&scoped=true&"
import script from "./BusinessInfo.vue?vue&type=script&lang=ts&"
export * from "./BusinessInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessInfo.vue?vue&type=style&index=0&id=000a31da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a31da",
  null
  
)

export default component.exports